import MadApp from './MadApp';

export default MadApp;